<template>
    <a-modal
        :class="'modal epic-default'"
        :title="$t('claims.remove_data.title')"
        :destroyOnClose="true"
        v-model:open="modal_visible"
        width="auto"
        :dialog-style="{ padding: '0 20px', maxWidth: '720px' }"
    >
        <template #footer>
            <a-button
                key="submit"
                type="primary"
                data-cy="claim-remove-data-submit"
                :loading="processing"
                :disabled="fileList.length == 0"
                @click="handleSubmit"
            >
                {{ $t('claims.remove_data.submit') }}
            </a-button>
        </template>
        <a-upload-dragger
            name="file"
            data-cy="claim-remove-data-drag"
            @remove="handleRemove"
            :file-list="fileList"
            :multiple="true"
            :before-upload="beforeUpload"
        >
            <p class="ant-upload-drag-icon">
                <InboxOutlined />
            </p>
            <p class="ant-upload-text">{{ $t('claims.remove_data.body') }}</p>
            <p class="ant-upload-hint">{{ $t('claims.remove_data.hint') }}</p>
        </a-upload-dragger>
    </a-modal>
</template>

<script>
import { InboxOutlined } from '@ant-design/icons-vue';

export default {
    components: { InboxOutlined },
    data() {
        return {
            modal_visible: false,
            fileList: [],
            fileLimit: -3,
        };
    },
    props: {
        processing: {
            type: Boolean,
            default: false,
        },
    },
    methods: {
        showModal() {
            this.fileList = [];
            this.modal_visible = true;
        },
        handleSubmit() {
            const { fileList } = this;
            const formData = new FormData();

            fileList.forEach((file) => {
                formData.append('files[]', file);
            });
            this.$emit('formSubmit', formData);
        },
        handleRemove(file) {
            const index = this.fileList.indexOf(file);
            const newFileList = this.fileList.slice();
            newFileList.splice(index, 1);
            this.fileList = newFileList;
        },
        beforeUpload(file) {
            const isCSV = file.type === 'text/csv';
            const isText = file.type === 'text/plain';

            if (isCSV || isText) {
                if (this.fileList.some((value) => value.name.toLowerCase() == file.name.toLowerCase())) {
                    this.$notification.error({
                        message: this.$t('validation.exists_already', { attribute: 'file' }),
                    });
                } else {
                    this.fileList = [...this.fileList, file].slice(this.fileLimit);
                }
            } else {
                this.$notification.error({
                    message: this.$t('validation.mimes', { attribute: 'File', values: 'CSV or TXT' }),
                });
            }
            return false;
        },
    },
};
</script>
